import { render, staticRenderFns } from "./SpecialFinanceDataField.vue?vue&type=template&id=e4b80046"
import script from "./SpecialFinanceDataField.vue?vue&type=script&lang=js"
export * from "./SpecialFinanceDataField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports